// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackButton__button-a1fd7d {
  position: absolute;
  top: 16px;
  inset-inline-start: 16px;
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/Pages/Components/BackButton/BackButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,wBAAA;AACF","sourcesContent":[".button {\n  position: absolute;\n  top: 16px;\n  inset-inline-start: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `BackButton__button-a1fd7d`
};
module.exports = ___CSS_LOADER_EXPORT___;
